import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AdminsettingsService {
  private http = inject(HttpClient);


  public getSettingsJSON(): Observable<any> {
    return this.http.get('assets/json/adminsettings.json');
  }

  public getEnterpriseSettingsJSON(): Observable<any> {
    return this.http.get('assets/json/enterprisesettings.json');
  }
}
